import axios from "axios";
import { HideLoading, ShowLoading } from "./loadingAction";
import swal from "sweetalert";
import { SignOut } from "./authActions";
import { CREATE_LICENSE, GET_LICENSE } from "./type";

import { license } from "../../API/Api";

export const postLicense = (data) => {
  return async (dispatch) => {
    dispatch(ShowLoading());
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
    await axios({
      method: "POST",
      baseURL: `${license}`,
      headers: headers,
      data,
    })
      .then((res) => {
        dispatch(HideLoading());
        swal({
          title: "Succsfully",
          text: "The License has been created successfully",
          icon: "success",
          button: `OK`,
        });
      })
      .catch((err) => {
        console.log("Errrrrrrrr", err.response);
        swal({
          title: "Error",
          text: "The License has not been created",
          icon: "error",
          button: `OK`,
        });
        dispatch({
          type: CREATE_LICENSE,
          payload: err.response,
        });

        dispatch(HideLoading());
        if (err?.response?.status === 401) {
          dispatch(SignOut());
        }
      });
  };
};

export const getLicense = (data) => {
  return async (dispatch) => {
    dispatch(ShowLoading());
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
    await axios({
      method: "GET",
      baseURL: `${license}`,
      headers: headers,
    })
      .then((res) => {
        dispatch({
          type: GET_LICENSE,
          payload: res.data,
        });
        dispatch(HideLoading());
      })
      .catch((err) => {
        dispatch(HideLoading());

        if (err?.response?.status === 401) {
          dispatch(SignOut());
        }
      });
  };
};
